// EXZMOTO SHOPIFY THEME — theme.js

(function () {
  'use strict';

  // ── SCROLL: sticky header shadow ──────────────────────────────
  var header = document.getElementById('SiteHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── SEARCH TOGGLE ─────────────────────────────────────────────
  var searchToggle = document.getElementById('SearchToggle');
  var searchBar = document.getElementById('SearchBar');
  var searchClose = document.getElementById('SearchClose');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('open');
      searchBar.setAttribute('aria-hidden', String(!open));
      if (open) setTimeout(function () { searchBar.querySelector('.nav-search-input').focus(); }, 300);
    });
  }
  if (searchClose && searchBar) {
    searchClose.addEventListener('click', function () {
      searchBar.classList.remove('open');
      searchBar.setAttribute('aria-hidden', 'true');
    });
  }


  // ── NAV DROPDOWNS — click + hover with delay buffer ──────────
  var dropdowns = document.querySelectorAll('.nav-dropdown');
  var closeTimers = [];

  dropdowns.forEach(function (dd, i) {
    closeTimers[i] = null;

    function openDD() {
      // Close all others first
      dropdowns.forEach(function (other, j) {
        if (j !== i) {
          other.classList.remove('open');
          var link = other.querySelector('.nav-link--has-dropdown');
          if (link) link.setAttribute('aria-expanded', 'false');
        }
      });
      clearTimeout(closeTimers[i]);
      dd.classList.add('open');
      var link = dd.querySelector('.nav-link--has-dropdown');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function closeDD() {
      closeTimers[i] = setTimeout(function () {
        dd.classList.remove('open');
        var link = dd.querySelector('.nav-link--has-dropdown');
        if (link) link.setAttribute('aria-expanded', 'false');
      }, 120); // 120ms buffer — enough to move mouse into menu
    }

    // Mouse enter/leave on the whole dropdown wrapper (link + menu)
    dd.addEventListener('mouseenter', openDD);
    dd.addEventListener('mouseleave', closeDD);

    // Also support click on the toggle link for touch-friendly
    var toggleLink = dd.querySelector('.nav-link--has-dropdown');
    if (toggleLink) {
      toggleLink.addEventListener('click', function (e) {
        if (dd.classList.contains('open')) {
          // If already open, let the href navigate
          return;
        }
        e.preventDefault();
        openDD();
      });
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-dropdown')) {
      dropdowns.forEach(function (dd) { dd.classList.remove('open'); });
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      dropdowns.forEach(function (dd) { dd.classList.remove('open'); });
    }
  });

  // ── MOBILE MENU ───────────────────────────────────────────────
  var navToggle = document.getElementById('NavToggle');
  var mobileMenu = document.getElementById('MobileMenu');
  if (navToggle && mobileMenu) {
    navToggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      mobileMenu.setAttribute('aria-hidden', String(!open));
      navToggle.classList.toggle('active', open);
      navToggle.setAttribute('aria-expanded', String(open));
    });
  }
  // Mobile sub-menu toggles
  document.querySelectorAll('.mobile-nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = this.nextElementSibling;
      var open = sub.hidden;
      sub.hidden = !open;
      this.setAttribute('aria-expanded', String(open));
    });
  });

  // ── CART DRAWER ───────────────────────────────────────────────
  var cartToggle = document.getElementById('CartToggle');
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartOverlay');
  var cartDrawerClose = document.getElementById('CartDrawerClose');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) { cartOverlay.classList.add('open'); cartOverlay.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) { cartOverlay.classList.remove('open'); cartOverlay.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // Escape key closes cart + search + mobile
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      if (searchBar) { searchBar.classList.remove('open'); searchBar.setAttribute('aria-hidden', 'true'); }
      if (mobileMenu) { mobileMenu.classList.remove('open'); mobileMenu.setAttribute('aria-hidden', 'true'); if (navToggle) { navToggle.classList.remove('active'); navToggle.setAttribute('aria-expanded', 'false'); } }
    }
  });

  // ── CART DRAWER: AJAX qty update + remove ────────────────────
  function cartFetch(url, callback) {
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(callback)
      .catch(function (err) { console.error('Cart error:', err); });
  }

  function refreshCartDrawer() {
    // Re-render just the drawer's line items / free-shipping goal bar /
    // subtotal via the alt "drawer-body" cart view (templates/cart.drawer-body.liquid)
    // so it reflects the latest cart contents without a full page reload.
    fetch('/cart?view=drawer-body', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var main = document.getElementById('CartDrawerMain');
        if (main) main.innerHTML = html;
      })
      .catch(function (err) { console.error('Cart drawer refresh error:', err); })
      .then(function () {
        // Runs after the drawer HTML is injected, so the freshly-rendered
        // discount UI gets repopulated instead of wiped.
        cartFetch('/cart.js', function (cart) {
          var count = document.getElementById('CartCount');
          if (count) count.textContent = cart.item_count;
          var drawerCount = document.getElementById('CartDrawerCount');
          if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
          updateDiscountUI(cart);
        });
      });
  }

  // Expose cart helpers for other scripts (bundle widget, product page)
  window.EXZCart = { open: openCartDrawer, close: closeCartDrawer, refresh: refreshCartDrawer };

  // ── DISCOUNT CODES (applied pre-checkout via Cart AJAX API) ───
  // Uses POST /cart/update.js { discount: "CODE1,CODE2" }. The cart JSON
  // response includes discount_codes[] (with .applicable) and total_discount,
  // so customers see their savings in the cart/drawer before checkout.
  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function updateDiscountUI(cart) {
    var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    document.querySelectorAll('[data-discount-chips]').forEach(function (wrap) {
      wrap.innerHTML = applied.map(function (d) {
        return '<span class="discount-chip">' + d.code.replace(/[<>&"]/g, '') +
          ' <button type="button" data-discount-remove data-code="' + d.code.replace(/[<>&"]/g, '') + '" aria-label="Remove code">x</button></span>';
      }).join('');
    });
    var savings = cart.total_discount || 0;
    document.querySelectorAll('[data-discount-savings]').forEach(function (row) {
      row.hidden = savings <= 0;
    });
    document.querySelectorAll('[data-discount-savings-amt]').forEach(function (el) {
      el.textContent = '-' + fmtMoney(savings);
    });
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = fmtMoney(cart.total_price);
    });
    var checkoutBtn = document.querySelector('.cart-checkout-btn');
    if (checkoutBtn) checkoutBtn.textContent = 'Checkout - ' + fmtMoney(cart.total_price);
  }

  function discountMsg(text, ok) {
    document.querySelectorAll('[data-discount-msg]').forEach(function (el) {
      el.hidden = !text;
      el.textContent = text || '';
      el.classList.toggle('discount-msg--ok', !!ok);
    });
  }

  function setDiscounts(codes, onDone) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: codes.join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (onDone) onDone(cart); })
      .catch(function (err) { console.error('Discount error:', err); discountMsg('Could not apply code. Try again.'); });
  }

  function currentCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }

  function applyDiscountCode(code) {
    if (!code) return;
    discountMsg('');
    cartFetch('/cart.js', function (cart) {
      var codes = currentCodes(cart);
      if (codes.indexOf(code) === -1) codes.push(code);
      setDiscounts(codes, function (updated) {
        var entry = (updated.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
        if (entry && entry.applicable) {
          discountMsg('Code applied!', true);
          document.querySelectorAll('[data-discount-input]').forEach(function (i) { i.value = ''; });
        } else {
          discountMsg('This code isn’t valid or doesn’t apply to your cart.');
          // strip the failed code so it doesn't linger
          setDiscounts(currentCodes(updated), function () {});
        }
        updateDiscountUI(entry && entry.applicable ? updated : updated);
        refreshCartDrawer();
      });
    });
  }

  function removeDiscountCode(code) {
    cartFetch('/cart.js', function (cart) {
      var codes = currentCodes(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      setDiscounts(codes, function (updated) {
        discountMsg('');
        updateDiscountUI(updated);
        refreshCartDrawer();
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var applyBtn = e.target.closest('[data-discount-apply]');
    if (applyBtn) {
      var ui = applyBtn.closest('[data-discount-ui]');
      var input = ui && ui.querySelector('[data-discount-input]');
      if (input) applyDiscountCode(input.value.trim());
    }
    var removeBtn = e.target.closest('[data-discount-remove]');
    if (removeBtn) {
      removeDiscountCode(removeBtn.dataset.code);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.hasAttribute && e.target.hasAttribute('data-discount-input')) {
      e.preventDefault();
      applyDiscountCode(e.target.value.trim());
    }
  });

  // Populate discount UI on page load (codes persist in the cart between pages)
  cartFetch('/cart.js', function (cart) { updateDiscountUI(cart); });

  // ── SMOOTH CHECKOUT TRANSITION ────────────────────────────────
  // Fade the storefront out as we hand off to Shopify's checkout page,
  // so the jump between pages feels intentional instead of abrupt.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.cart-drawer-checkout');
    if (link) {
      e.preventDefault();
      document.body.classList.add('page-exit');
      var href = link.getAttribute('href') || '/checkout';
      setTimeout(function () { window.location.href = href; }, 280);
      return;
    }
    // Cart page checkout submit — let the form submit naturally, just fade
    if (e.target.closest && e.target.closest('.cart-checkout-btn')) {
      document.body.classList.add('page-exit');
    }
  });

  document.addEventListener('click', function (e) {
    // Drawer "Continue Shopping" (empty state)
    if (e.target.classList.contains('cart-drawer-close-btn')) {
      closeCartDrawer();
    }
    // Drawer remove
    if (e.target.classList.contains('drawer-remove') || e.target.classList.contains('cart-drawer-remove')) {
      var line = e.target.dataset.line;
      if (!line) return;
      e.preventDefault();
      cartFetch('/cart/change.js?line=' + line + '&quantity=0', function () { refreshCartDrawer(); });
    }
    // Drawer qty minus
    if (e.target.classList.contains('drawer-qty-minus')) {
      var line = e.target.dataset.line;
      var displayEl = document.getElementById('DrawerQty-' + line);
      var qty = displayEl ? Math.max(0, parseInt(displayEl.textContent) - 1) : 0;
      cartFetch('/cart/change.js?line=' + line + '&quantity=' + qty, function () { refreshCartDrawer(); });
    }
    // Drawer qty plus
    if (e.target.classList.contains('drawer-qty-plus')) {
      var line = e.target.dataset.line;
      var displayEl = document.getElementById('DrawerQty-' + line);
      var qty = displayEl ? parseInt(displayEl.textContent) + 1 : 1;
      cartFetch('/cart/change.js?line=' + line + '&quantity=' + qty, function () { refreshCartDrawer(); });
    }
  });

  // ── ADD TO CART: open drawer ──────────────────────────────────
  document.querySelectorAll('.product-card-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartDrawer();
          openCartDrawer();
        })
        .catch(function (err) { console.error('Add to cart error:', err); });
    });
  });

  // Main product ATC form
  var atcForm = document.getElementById('AddToCartForm');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(atcForm);
      var btn = document.getElementById('AddToCart');
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartDrawer();
          openCartDrawer();
          if (btn) {
            btn.textContent = 'Added!';
            setTimeout(function () {
              btn.disabled = false;
              var vid = document.getElementById('VariantId');
              var price = vid ? '' : '';
              btn.textContent = 'Add to Cart';
            }, 2000);
          }
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; } });
    });
  }

  // ── SCROLL REVEAL ─────────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var fadeEls = document.querySelectorAll('.bike-card, .col-card, .product-card, .feat-card, .why-feature, .blog-card');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-fade', '');
          requestAnimationFrame(function () { entry.target.classList.add('visible'); });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    fadeEls.forEach(function (el) {
      el.setAttribute('data-fade', '');
      observer.observe(el);
    });
  }

  // ── PRODUCT RECOMMENDATIONS (async) ───────────────────────────
  var recContainer = document.getElementById('ProductRecommendations');
  if (recContainer && recContainer.dataset.url) {
    fetch(recContainer.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var recs = doc.getElementById('ProductRecommendations');
        if (recs) recContainer.innerHTML = recs.innerHTML;
      })
      .catch(function () {});
  }

})();